import _capitalize from 'lodash/capitalize';
import _find from 'lodash/find';
import _isEmpty from 'lodash/isEmpty';
import _lowerCase from 'lodash/lowerCase';
import _upperCase from 'lodash/upperCase';
import config from '../../app/config';

export const isCentralPageModuleEnabled = !!config?.modules?.centralPage?.enabled;

export const getActiveAvatar = (preferences) => preferences?.avatar?.customAvatar?.active ? 'custom' : 'default';

export const getAvatarColor = (preferences) =>  preferences?.avatar?.avatarBackground;

export const getAvatarFontColor = (preferences) =>  preferences?.avatar?.avatarFontColor;

export const getUserInitials = (user) => {
  let initials = '';

  if (user?.firstName) {
    initials += user?.firstName?.at(0);
  }

  if (user?.familyName) {
    initials += user?.familyName?.at(0);
  }

  return _upperCase(initials);
}

export const getGroupedObjectKey = (specialty) => `${specialty?.__id}-${_lowerCase(specialty?.__description)}`;

export const getGroupedObjectSpecialtyCode = (objKey) => objKey.split('-')?.[0];

export const getGroupedObjectSpecialtyDescription = (objKey) => objKey.split('-')?.[1];

export const getConsultantName = (consultant) => {
  if (!consultant) return '';

  let consultantNameString = '';

  if (!!consultant?.title) {
    consultantNameString += `${_capitalize(consultant?.title)} `;
  }

  if (!!consultant?.firstName) {
    consultantNameString += _capitalize(consultant?.firstName);
  }

  if (consultant?.familyName) {
    let capitalizedFamilyName = consultant?.familyName.split("-").map(_capitalize).join('-')
    consultantNameString += ` ${capitalizedFamilyName}`;
  }

  return consultantNameString;
}

export const getConsultantWithDefaultAdmittingSpecialty = (assignedConsultantId, consultants) => {
  if (!_isEmpty(consultants) && !!assignedConsultantId) {
    const cons = _find(consultants, { __id: assignedConsultantId});

    return cons || null;
  }

  return null;
}

export const getBulkObjectChange = (change, ward) => {
  return ({
    currentWard: ward,
    consultant: change?.consultant,
    specialty: change?.specialty,
    previousConsultant: change?.previousConsultant
  })
}

export const prepareAdmitConsultantChanges = ({ currentWard, consultant, specialty, previousConsultant }) => {
  const dataObj = {
    specialtyId: specialty?.__id || "",
    wardId: currentWard?.name || "",
    specialtyCode: specialty?.__code || "",
    assignedConsultantId: consultant?.__id || "",
  };

  const auditData = {
    ...dataObj,
    specialtyName: specialty?.__description || "",
    consultantName: getConsultantName(consultant),
    previousConsultantId: previousConsultant ? previousConsultant?.__id : 'unset',
    previousConsultantName: getConsultantName(previousConsultant),
  };

  return { dataObj, auditData };
}